import { ElementType } from "../../library-js/dom-tools/ElementType";
import { DragData } from "../../library-js/dom-ui/basics/DragData";

import { OnDrag, Events } from "../../library-js/dom-tools/EventListeners";
import { DOMHitTest } from "../../library-js/dom-tools/DOMHitTest";
import { HTMLEditor } from "../../library-js/dom-tools/HTMLEditor";
import { Vector2 } from "three";
import { RegExpUtility } from "../../library-js/text/RegExpUtility";

import { TemplateDefaults } from "../TemplateDefaults";
import { NodeGraph } from "./model/NodeGraph";
import { NodeGraphUI } from "./ui/NodeGraphUI";


export class NodeGraphView
{

  static applyOnDocument()
  {
    NodeGraphUI.type.forAllInDoc( ngElement => NodeGraphView.applyOnElement( ngElement ) );
  }

  static applyOnElement( ngElement:Element )
  { 
    let nodeGraph = new NodeGraph();
    nodeGraph.initialize( ngElement );
  }
}